import { useCallback, useState } from 'react';
import classNames from 'classnames';
import { Button } from 'antd';
import { prepareHubspotData, sendToAmplitude, sendToHubspot, useFormData } from '../../model';
import s from './index.module.css';

const roles = [
    'Security Specialist',
    'Security Manager',
    'Software Engineer',
    'Engineering Manager',
    'DevOps Specialist',
    'DevOps Manager',
    'System Architect',
    'Executive Leadership',
    'Other'
];

export const Role = () => {
    const { email, nextStep } = useFormData();
    const [answer, setAnswer] = useState('');

    const handleChoose = useCallback((role: string) => {
        setAnswer(role);
        sendToAmplitude(`WALLARMCOM_AASM_ROLE`);
    }, []);

    const handleBack = useCallback(() => nextStep('team'), []);
    const handleNext = useCallback(async () => {
        sendToAmplitude(`WALLARMCOM_AASM_ROLE_SUBMITTED`, { role: answer });
        await sendToHubspot(prepareHubspotData({ email, role: answer }));
        nextStep('invite');
    }, [email, answer]);

    return (
        <>
            <div className={s.block}>
                {roles.map(item => (
                    <div
                        key={item}
                        onClick={() => handleChoose(item)}
                        className={classNames(s.item, item === answer && s.checked)}
                    >
                        {item}
                    </div>
                ))}
            </div>
            <div className={s.actions}>
                <Button size='large' onClick={handleBack}>
                    Back
                </Button>
                <Button type='primary' size='large' disabled={!answer} onClick={handleNext}>
                    Next
                </Button>
            </div>
        </>
    );
};
